import {
    CreateListPayload,
    ManualSyncPayload,
    UpdateConectionPayload,
} from '@app/_models/integrations/envialo-simple.model';
import { GoogleAnalyticsConfig, GetConfigPayload } from '@app/_models/integrations/google_analytics.model';
import {
    GetConfigPayload as FacebookPixelsConfigPayload,
    FacebookPixelsConfig,
} from '@app/_models/integrations/facebook_pixels.model';

export class SetIntegrationsNav {
    public static readonly type = '[Integrations] SetIntegrationsNav';
}

export class ToogleExecuteSubmit {
    public static readonly type = '[Integrations] ToogleExecuteSubmit';
    constructor(public execute: boolean) {}
}
export class SetLoadingFormSubmitIntegrationAction {
    public static readonly type = '[Integrations] SetLoadingFormSubmitIntegrationAction';
    constructor(public data: boolean) {}
}

export class GetEnvialoSimpleMailList {
    public static readonly type = '[Integrations] GetenvialoSimpleMailList';
}

export class GetEnvialoSimpleConfig {
    public static readonly type = '[Integrations] GetenvialoSimpleConfig';
}

export class CreateContactList {
    public static readonly type = '[Integrations] CreateContactList';
    constructor(public payload: CreateListPayload) {}
}

export class SetEnvialoSimpleConfig {
    public static readonly type = '[Integrations] SetEnvialoSimpleConfig';
    constructor(public payload: UpdateConectionPayload, public showToasts: boolean) {}
}

export class ManualSync {
    public static readonly type = '[Integrations] ManualSync';
    constructor(public payload: ManualSyncPayload) {}
}

export class ClearEnvialoData {
    public static readonly type = '[Integrations] ManualSync';
    constructor() {}
}

export class SaveAfip960 {
    public static readonly type = '[Integrations] SaveAfip960';
    constructor(public payload: any) {}
}

export class GetAfip960Data {
    public static readonly type = '[Integrations] GetAfip960Data';
    constructor() {}
}

export class GetGoogleAnalyticsConfig {
    public static readonly type = '[Integrations] GetGoogleAnalyticsConfig';
    constructor(public payload: GetConfigPayload) {}
}

export class SetGoogleAnalyticsConfig {
    public static readonly type = '[Integrations] SetGoogleAnalyticsConfig';
    constructor(public payload: GoogleAnalyticsConfig) {}
}

export class GetFacebookPixelsConfig {
    public static readonly type = '[Integrations] GetFacebookPixelsConfig';
    constructor(public payload: FacebookPixelsConfigPayload) {}
}

export class SetFacebookPixelsConfig {
    public static readonly type = '[Integrations] SetFacebookPixelsConfig';
    constructor(public payload: FacebookPixelsConfig) {}
}
